import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Notification } from './notification.interface';

export interface NotificationState {
   notifications: Array<Notification>;
   notificationsHistory: Array<Notification>;
}

const NotificationStore: Module<NotificationState, StoreState> = {
   namespaced: true,
   state: {
      notifications: [],
      notificationsHistory: [],
   },
   getters: {
      notifications: (state) => state.notifications,
      notificationsHistory: (state) => state.notificationsHistory,
   },
   mutations: {
      SET_NOTIFICATIONS(state, notifications: Array<Notification> = []) {
         state.notifications = notifications;
      },
      SET_NOTIFICATIONS_HISTORY(state, notifications: Array<Notification> = []) {
         state.notificationsHistory = notifications;
      },
      ADD_NOTIFY(state, notification: Notification) {
         state.notifications.push(notification);
         state.notificationsHistory.unshift(notification);
      },
      REMOVE_NOTIFICATION(state, key: string) {
         const index = state.notifications.findIndex((n) => n.key === key);
         if (index > -1) state.notifications.splice(index, 1);
      },
      REMOVE_HISTORY_NOTIFICATION(state, key: string) {
         const index = state.notificationsHistory.findIndex((nh) => nh.key === key);
         if (index > -1) state.notificationsHistory.splice(index, 1);
      },
   },
   actions: {
      add(context, notification: Partial<Notification>) {
         context.commit('ADD_NOTIFY', {
            ...notification,
            key: notification.key || `${new Date().toISOString()}${Math.random()}`,
            timeout: notification.timeout === null ? notification.timeout : notification.timeout || 5000,
         });
      },
      remove(context, key: string) {
         context.commit('REMOVE_NOTIFICATION', key);
      },
      removeHistoryNotification(context, key: string) {
         context.commit('REMOVE_NOTIFICATION', key);
         context.commit('REMOVE_HISTORY_NOTIFICATION', key);
      },
      clear(context) {
         context.commit('SET_NOTIFICATIONS', []);
      },
      clearHistory(context) {
         context.commit('SET_NOTIFICATIONS_HISTORY', []);
      },
   },
};

export default NotificationStore;
